import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notion-list-container"
}
const _hoisted_2 = { class: "notion-list-header" }
const _hoisted_3 = { class: "notion-list-header-left" }
const _hoisted_4 = { class: "notion-list-title" }
const _hoisted_5 = { class: "notion-list-header-right" }
const _hoisted_6 = {
  key: 0,
  class: "notion-search-wrapper"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search notion-search-icon" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "notion-filter-btn" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-funnel" }),
  /*#__PURE__*/_createElementVNode("span", null, "Filter")
], -1)
const _hoisted_10 = ["data-bs-target"]
const _hoisted_11 = { class: "notion-list-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MappingBlocks = _resolveComponent("MappingBlocks")!
  const _component_AppliedFilters = _resolveComponent("AppliedFilters")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_DataGridWithLeagues = _resolveComponent("DataGridWithLeagues")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_RowDetailsModal = _resolveComponent("RowDetailsModal")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!

  return (_ctx.mapping?.map)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.mapping.map.Components)
          ? (_openBlock(), _createBlock(_component_MappingBlocks, {
              key: 0,
              components: _ctx.mapping.map.Components
            }, null, 8, ["components"]))
          : _createCommentVNode("", true),
        _createVNode(_component_AppliedFilters, {
          class: "notion-applied-filters",
          filters: _ctx.appliedFilters,
          onRemove: _ctx.onRemoveFilter
        }, null, 8, ["filters", "onRemove"]),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.widgetClasses, "notion-list-panel"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.pageName), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.mapping?.map && !_ctx.mapping.map.SearchDisabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSearchTerm) = $event)),
                      onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchKeyUp && _ctx.searchKeyUp(...args))),
                      type: "text",
                      class: "notion-search-input",
                      name: "Search",
                      placeholder: "Search..."
                    }, null, 544), [
                      [_vModelText, _ctx.localSearchTerm]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getFiltersMapping && _ctx.getFiltersMapping.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_Popper, { placement: "bottom" }, {
                      content: _withCtx(() => [
                        _createVNode(_component_Dropdown1, { routeKey: _ctx.routeKey }, null, 8, ["routeKey"])
                      ]),
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.multipleFormEdit)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    "data-bs-toggle": "modal",
                    "data-bs-target": '#kt_modal_new_card_' + _ctx.routeKey,
                    class: "btn btn-sm btn-primary",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onMultipleEdit && _ctx.onMultipleEdit(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.mapping.map.MultipleFormButton), 9, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.mapping.map.RenderAsLeagueGrid)
              ? (_openBlock(), _createBlock(_component_DataGridWithLeagues, {
                  key: 0,
                  title: _ctx.pageName,
                  "route-key": _ctx.routeKey,
                  mapping: _ctx.mapping.map,
                  items: _ctx.items,
                  onOpenModal: _ctx.onOpenModal,
                  onDelete: _ctx.onDelete,
                  onRowAction: _ctx.onRowAction
                }, null, 8, ["title", "route-key", "mapping", "items", "onOpenModal", "onDelete", "onRowAction"]))
              : (_openBlock(), _createBlock(_component_DataTable, {
                  key: 1,
                  "route-key": _ctx.routeKey,
                  mapping: _ctx.mapping.map,
                  items: _ctx.items,
                  "sort-by": _ctx.sortBy,
                  pagination: _ctx.pagination,
                  onSort: _ctx.onSort,
                  onOpenModal: _ctx.onOpenModal,
                  onDelete: _ctx.onDelete,
                  onRowAction: _ctx.onRowAction,
                  onMoveUp: _ctx.onMoveUp,
                  onMoveDown: _ctx.onMoveDown
                }, null, 8, ["route-key", "mapping", "items", "sort-by", "pagination", "onSort", "onOpenModal", "onDelete", "onRowAction", "onMoveUp", "onMoveDown"])),
            (_ctx.rowModalConfig)
              ? (_openBlock(), _createBlock(_component_RowDetailsModal, {
                  key: 2,
                  id: _ctx.rowModalId,
                  title: _ctx.rowModalConfig.title,
                  fields: _ctx.rowModalConfig.fields,
                  data: _ctx.rowModalData,
                  loading: _ctx.rowModalLoading
                }, null, 8, ["id", "title", "fields", "data", "loading"]))
              : _createCommentVNode("", true),
            (_ctx.pagination)
              ? (_openBlock(), _createBlock(_component_PaginationBar, {
                  key: 3,
                  page: _ctx.pagination.currentPage,
                  "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination.currentPage) = $event)),
                  total: _ctx.pagination.totalItems,
                  "per-page": _ctx.pagination.paginate,
                  onChange: _ctx.onPaginate
                }, null, 8, ["page", "total", "per-page", "onChange"]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}